export const OPERATION_KIND_HEADER = "x-operation-kind";

export const OPERATION_KINDS = ["account", "connector", "fixture"] as const;

export type OperationKind = (typeof OPERATION_KINDS)[number];

export function parseOperationKind(value: unknown): OperationKind | null {
  if (typeof value !== "string") return null;
  const normalized = value.trim().toLowerCase();
  return OPERATION_KINDS.includes(normalized as OperationKind)
    ? (normalized as OperationKind)
    : null;
}
